export default __webpack_public_path__ + "static/media/header-background-dots-pattern.707be104.svg";